module.exports = __webpack_public_path__ + "img/cctv.ee0834b0.png";